<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card>
                <v-card-title>
                    {{$t('settingstrans.management')}} {{marchand_name}}
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>

                  <div class="pl-4 pr-4 col-md-12 ">
                        <v-alert
                          v-model="alert"
                          border="left"
                          close-text="Close Alert"
                          color="info"
                          dark
                          dismissible
                          style="font-size: 11pt"
                        >
                          {{$t('settingstrans.managementinfo')}}
                        </v-alert>

                      </div>


                <v-data-table
                        :headers="headers"
                        :items="settingtransactions"
                        :search="search"
                        sort-by="name"
                        class="elevation-1"
                        :loading="load"
                        loading-text="Chargement en cours..."

                >

                    <template v-slot:item._taux="{ item }">
                        <v-chip color="primary" dark>{{ item._taux }} %</v-chip>
                    </template>

                    <template v-slot:item._means_paiement="{ item }">
                       <span>{{item._means_paiement._name}} - {{item._means_paiement._country._name}} </span>
                    </template>


                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-spacer></v-spacer>
                            <v-dialog v-model="dialog" max-width="500px">
                                <template v-slot:activator="{ on }">
                                    <v-btn style="background: #29B3A6;color: #fff" class="mb-2" v-on="on">{{$t('settingstrans.new')}}
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>


                                        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                            <v-alert v-if="errors" dense outlined
                                                     :type="(errors.update_error)?'error':'success'">
                                                {{$t(errors.operation)}}
                                            </v-alert>

                                            <v-text-field v-if="submitting" color="primary" loading
                                                          disabled></v-text-field>
                                            <v-row>

                                                <v-col class="d-flex" cols="12" sm="6" md="12">
                                                    <v-select
                                                            :rules="meanspaiementsRules"
                                                            id="means"
                                                            v-model="editedItem._means_paiement"
                                                            item-text="_name"
                                                            item-value="_id"
                                                            :items="means_paiements"
                                                            :label="$t('settingstrans.means')"
                                                            :placeholder="$t('settingstrans.placeholder')"
                                                            dense
                                                            required

                                                    >
                                                        <template slot="selection" slot-scope="data">
                                                            <!-- HTML that describe how select should render selected items -->
                                                            {{ data.item._name }} - {{ data.item._country._name }}
                                                        </template>
                                                        <template slot="item" slot-scope="data">
                                                            <!-- HTML that describe how select should render items when the select is open -->
                                                            {{ data.item._name }} - {{ data.item._country._name }}
                                                        </template>
                                                    </v-select>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="12">
                                                    <v-slider
                                                            v-model="editedItem._taux"
                                                            color="black"
                                                            :label="$t('means_paiement.taux')+' = '+editedItem._taux "
                                                            min="1"
                                                            max="100"
                                                            thumb-label
                                                    ></v-slider>

                                                </v-col>

                                            </v-row>
                                        </v-form>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="dark" text @click="close">{{$t('cancel')}}</v-btn>
                                        <v-btn class="primary"  :disabled="!valid" text @click="save">{{$t('save')}}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <div style="text-align:  right">
                          <v-menu
                                  key="text"
                                  rounded="b-xl">
                              <template v-slot:activator="{ attrs, on }">

                                      <v-icon

                                      class="black--text "
                                      v-bind="attrs"
                                      v-on="on">mdi-dots-vertical</v-icon>

                              </template>
                                <v-list>
                                    <v-list-item
                                            v-for="(action_item, index) in actions_items"
                                            :key="index"
                                            link
                                            @click="editItemAction(item,index)">
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">{{action_item.avatar}}</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title v-text="action_item.title"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </template>
                    <template v-slot:no-data>
                        {{$t('no_data')}}
                    </template>
                </v-data-table>
            </v-card>
        </div>
        <customsnackbar :snackbar="customSnack.snackbar"
        :text="customSnack.text"
        :snackcolor="customSnack.snackcolor" :snackbBtnColor="customSnack.snackbBtnColor"
        :snacktimeout="customSnack.snacktimeout" > </customsnackbar>
    </div>

</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
      import helpers from "../../mixins/helpers";

    export default {

        label: "Cities",
        mixins:[helpers(this)],
        data() {
            return {
                submitting: false,
                alert: true,
                customSnack:{
                      snackbar: false,
                      text: "",
                      snackcolor:"black",
                      snackbBtnColor:"white",
                      snacktimeout:2000
                    },
                valid: true,
                lazy: false,
                errors:undefined,
                search: '',
                dialog: '',
                id: undefined,
                marchand_name:"",
                headers: [
                    {
                        text: 'Moyen de paiement',
                        align: 'start',
                        sortable: true,
                        value: '_means_paiement',
                    },
                    {text: 'Taux', value: '_taux'},
                    {text: '', value: 'actions', sortable: false},

                ],
                editedIndex: -1,
                editedItem: {
                    _taux: 1,
                    _means_paiement: '',
                    _id: 0,
                    _created_at: 0,
                },
                defaultItem: {
                    _taux: 1,
                    _means_paiement: '',
                    _id: 0,
                    _created_at: 0,
                },
                meanspaiementsRules: [
                    v => !!v || 'Choix requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                actions_items: [
                    { title: "Modifier", avatar: 'mdi-pencil' },
                    { title: "Supprimer", avatar: 'mdi-delete' }
                ]

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? this.$t('settingstrans.new') : this.$t('settingstrans.update')
            }
            ,
            ...mapState('settingtransactions/',['settingtransactions','load','themarchand'])
            ,
            ...mapState('means_paiements/', ['means_paiements'])

        }
        ,
        mounted() {

            let data = new FormData();
            data.append("id", this.$route.params.id);
            this.$store.dispatch('settingtransactions/getMarchandWithSetting',data).then(response=>{
                console.log('documents',this.$store.state.settingtransactions)
               this.marchand_name = this.$store.state.settingtransactions.themarchand._company;
            });
            let data2 = new FormData();
            data2.append("marchand_id", this.$route.params.id);
            this.$store.dispatch('means_paiements/getOtherForMarchand',data2).then(response => {
                window.console.log('means_paiements', response)
            });
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            }
            ,
            editItemAction(item,index) {
                switch (index){

                    case 0:
                        this.editItem(item)
                        break;
                    case 1:
                        this.deleteItem(item)
                        break;

                }
            },

            editItem(item) {
              this.customSnack.snackbar = false;

                this.editedIndex = this.settingtransactions.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.editedItem._means_paiement = item._means_paiement._id;
                this.editedItem._taux = item._taux;
                this.editedItem._id = item._id;
                console.log("this.editedItem",this.editedItem);
                this.dialog = true;
            }
            ,

            deleteItem(item) {
              this.customSnack.snackbar = false;

                const index = this.settingtransactions.indexOf(item);
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t('delete_warning'),
                    confirmButtonText: this.$t('delete'),
                    cancelButtonText: this.$t('cancel'),
                    showCancelButton: true,
                    cancelButtonColor:"#CCC",
                    confirmButtonColor:"#29B3A6"
                }).then(result => {
                    if (result.value) {
                        let data = new FormData();
                        data.append("id", item._id);
                        data.append("marchand_id", this.$route.params.id);
                        this.$store.dispatch('settingtransactions/deleteSetting', data).then((response) => {

                          this.showSnackDefault(response);

                          let data2 = new FormData();
                          data2.append("marchand_id", this.$route.params.id);
                          this.$store.dispatch('means_paiements/getOtherForMarchand',data2).then(response => {
                              window.console.log('means_paiements', response)
                          });
                        })
                    }
                })
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save() {
                this.customSnack.snackbar = false;
                console.log(this.editedItem);
                this.submitting = true;
                let data = new FormData();
                data.append("taux", this.editedItem._taux);
                data.append("means", this.editedItem._means_paiement);
                data.append("marchand_id", this.$route.params.id);
                let mineroute = 'settingtransactions/setSetting';
                if (this.editedIndex>-1){
                    data.append("id",this.editedItem._id);
                    mineroute = 'settingtransactions/updateSetting';
                }
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('set cities response', response);
                    this.submitting = false;
                    if (response.data.error) {
                        this.toast('error',response.data.message)
                    } else {

                        this.toast('success',response.data.message)
                    }
                    this.close();
                    let data2 = new FormData();
                    data2.append("marchand_id", this.$route.params.id);
                    this.$store.dispatch('means_paiements/getOtherForMarchand',data2).then(response => {
                        window.console.log('means_paiements', response)
                    });
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            fileChange() {
                console.log(this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file) {
                return file.substr(file.lastIndexOf('/') + 1)
            },
            checkIfExist(){
                let VueBox = this;
                if (VueBox.editedIndex>-1){
                    return VueBox.values.find(value => value._code === VueBox.editedItem.code && value._id !== VueBox.editedItem._id)
                } else{
                    return VueBox.values.find(value => value._code === VueBox.editedItem.code)
                }
            }
        }
        ,
        created() {
            this.checkisDashboard();
            this.initialize()
        }
    }
</script>

<style scoped>

</style>
